import React, { useEffect, useState } from "react";
import { Divider, Skeleton, Stack, Typography } from "@mui/material";
import { useNavigation } from "react-router-dom";
import TabSkeleton from "./TabSkeleton";

const TabLayout = ({
  headerLabel,
  children,
  skeletonLines = 10,
}) => {
  const [showSkeleton, setShowSkeleton] = useState(false);
  const navigation = useNavigation();

  useEffect(() => {
    let timer;
    if (navigation.state === "loading") {
      timer = setTimeout(() => {
        setShowSkeleton(true);
      }, 500);
    } else {
      setShowSkeleton(false);
    }
    return () => clearTimeout(timer);
  }, [navigation.state]);

  return (
    <Stack
      alignItems="end"
      width="100%"
      height="100%"
    >
      {showSkeleton && headerLabel ? (
        <Skeleton
          animation="pulse"
          style={{ marginRight: "1.5em" }}
        >
          <Typography variant="overline">
            {headerLabel}
          </Typography>
        </Skeleton>
      ) : (
        <Typography
          variant="overline"
          pr={3}
          style={{ userSelect: "none" }}
        >
          {headerLabel}
        </Typography>
      )}
      <Stack
        width="100%"
        height="100%"
      >
        <Divider sx={{ marginBottom: "20px" }}/>
        {showSkeleton ? (
          <TabSkeleton lines={skeletonLines}/>
        ) : (
          <>{children}</>
        )}
      </Stack>
    </Stack>
  );
};

export default TabLayout;